// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manual_edn {
  min-height: 80vh;
  overflow: auto;
}
.manual_edn::-webkit-scrollbar {
  width: 0.7em;
  height: 0.7em;
}
.manual_edn::-webkit-scrollbar-thumb {
  background: #2c53a0;
}
.manual_edn::-webkit-scrollbar-track {
  background: #96a9d0;
}
.manual_edn {
  scrollbar-face-color: #2c53a0;
  scrollbar-track-color: #96a9d0;
}
@media (max-width: 600px) {
  .manual_edn::-webkit-scrollbar {
    width: 0em;
    height: 0em;
  }
  .manual_edn::-webkit-scrollbar-thumb {
    background: #fff;
  }
  .manual_edn::-webkit-scrollbar-track {
    background: white;
  }
  .manual_edn {
    scrollbar-face-color: #fff;
    scrollbar-track-color: white;
  }
}
.manual_edn .header_info .header_indv {
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  gap: 10px;
}
.manual_edn .header_info .header_indv label {
  font-weight: 600;
}
.manual_edn .filter_container input,
.manual_edn .filter_container button {
  width: 46vw;
}
@media (max-width: 1000px) {
  .manual_edn .filter_container input {
    width: 94vw;
  }
  .manual_edn .filter_container button {
    width: 95vw;
    margin: 0.5vh auto;
  }
}
.manual_edn .products_selected {
  max-height: 35vh;
  overflow: auto;
}
.manual_edn .products_selected::-webkit-scrollbar {
  width: 0.7em;
  height: 0.7em;
}
.manual_edn .products_selected::-webkit-scrollbar-thumb {
  background: #2c53a0;
}
.manual_edn .products_selected::-webkit-scrollbar-track {
  background: #96a9d0;
}
.manual_edn .products_selected {
  scrollbar-face-color: #2c53a0;
  scrollbar-track-color: #96a9d0;
}
.manual_edn .products_selected table {
  width: 95vw;
  font-size: 0.9em;
  font-family: sans-serif;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
  margin: 2vh auto;
  table-layout: fixed;
}
.manual_edn .products_selected table thead {
  height: 4vh;
}
.manual_edn .products_selected table thead tr {
  background-color: #2c53a0;
  color: #ffffff;
  text-align: left;
}
.manual_edn .products_selected table thead tr th {
  text-align: center;
}
.manual_edn .products_selected table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.manual_edn .products_selected table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.manual_edn .products_selected table tbody tr:first-of-type {
  border-top: 2px solid #2c53a0;
}
.manual_edn .products_selected table tbody tr:last-of-type {
  border-bottom: 2px solid #2c53a0;
}
.manual_edn .products_selected table tbody tr td {
  padding: 12px 15px;
  word-wrap: break-word;
}
.manual_edn .products_selected table tbody tr td .input_number {
  border-radius: 3px;
  border: 2px solid #2c53a0;
  width: 50px;
  height: 3vh;
  text-align: center;
}
.manual_edn .products_selected table tbody tr td input::-webkit-outer-spin-button,
.manual_edn .products_selected table tbody tr td input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.manual_edn .products_selected table tbody tr td button {
  width: 100%;
}
@media (max-width: 1000px) {
  .manual_edn .table td:nth-of-type(1):before {
    content: "Product";
  }
  .manual_edn .table td:nth-of-type(2):before {
    content: "Quantity";
  }
  .manual_edn .table td:nth-of-type(3):before {
    content: "Remove";
  }
}
.manual_edn .table input {
  border-radius: 3px;
  width: 50px;
}
.manual_edn .btn_section {
  margin: 3vh auto;
}
.manual_edn .btn_section button {
  width: 50%;
  min-width: 300px;
}`, "",{"version":3,"sources":["webpack://./src/components/EDNs/manual-edn.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,gBAAA;EACA,cAAA;AADJ;ACwCI;EACI,YDvCgB;ECwChB,aDxCgB;AAExB;ACyCI;EACI,mBAhDI;ADSZ;AC0CI;EACI,mBAbe;AD3BvB;AC4CI;EACI,6BAzDI;EA0DJ,8BAnBe;ADvBvB;AAXI;ECqCA;IACI,UDrCoB;ICsCpB,WDtCoB;EAe1B;EC0BE;IACI,gBA1CA;EDkBN;EC2BE;IACI,iBAbe;EDZrB;EC6BE;IACI,0BAnDA;IAoDA,4BAnBe;EDRrB;AACF;AAtBQ;ECkBJ,aAAA;EACA,uBDlBsB;ECmBtB,kBDnB8B;ECoB9B,sBDpBqC;ECqBrC,SDrB6C;AA4BjD;AA3BY;EACI,gBAAA;AA6BhB;AAvBQ;;EAEI,WAAA;AAyBZ;AAvBQ;EACI;IACI,WAAA;EAyBd;EAvBU;IACI,WAAA;IACA,kBAAA;EAyBd;AACF;AArBI;EACI,gBAAA;EACA,cAAA;AAuBR;ACjBI;EACI,YDNoB;ECOpB,aDPoB;AA0B5B;AChBI;EACI,mBAhDI;ADkEZ;ACfI;EACI,mBAbe;AD8BvB;ACbI;EACI,6BAzDI;EA0DJ,8BAnBe;ADkCvB;AAlCQ;EACI,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,wCAAA;EACA,gBAAA;EACA,mBAAA;AAoCZ;AAnCY;EACI,WAAA;AAqChB;AApCgB;EACI,yBCjDR;EDkDQ,cAAA;EACA,gBAAA;AAsCpB;AArCoB;EACI,kBAAA;AAuCxB;AAjCgB;EACI,gCAAA;AAmCpB;AAjCoB;EACI,yBAAA;AAmCxB;AAjCoB;EACI,6BAAA;AAmCxB;AAjCoB;EACI,gCAAA;AAmCxB;AAhCoB;EACI,kBAAA;EACA,qBAAA;AAkCxB;AAjCwB;EACI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AAmC5B;AAjCwB;;EAEI,wBAAA;EACA,SAAA;AAmC5B;AAjCwB;EACI,WAAA;AAmC5B;AA1BQ;EACI;IACI,kBAAA;EA4Bd;EA1BU;IACI,mBAAA;EA4Bd;EA1BU;IACI,iBAAA;EA4Bd;AACF;AA1BQ;EACI,kBAAA;EACA,WAAA;AA4BZ;AAxBI;EACI,gBAAA;AA0BR;AAzBQ;EACI,UAAA;EACA,gBAAA;AA2BZ","sourcesContent":["@import \"../../variables.scss\";\n\n.manual_edn {\n    min-height: 80vh;\n    overflow: auto;\n    @include scrollbars(0.7em, $nitroDark);\n    @media (max-width: $mobile) {\n        @include scrollbars(0em, $white);\n    }\n\n    .header_info {\n        .header_indv {\n            @include flex(center, start, column, 10px);\n            label {\n                font-weight: 600;\n            }\n        }\n    }\n\n    .filter_container {\n        input,\n        button {\n            width: 46vw;\n        }\n        @media (max-width: $tablet) {\n            input {\n                width: 94vw;\n            }\n            button {\n                width: 95vw;\n                margin: 0.5vh auto;\n            }\n        }\n    }\n\n    .products_selected {\n        max-height: 35vh;\n        overflow: auto;\n        @include scrollbars(0.7em, $nitroDark);\n\n        table {\n            width: 95vw;\n            font-size: 0.9em;\n            font-family: sans-serif;\n            box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);\n            margin: 2vh auto;\n            table-layout: fixed;\n            thead {\n                height: 4vh;\n                tr {\n                    background-color: $nitroDark;\n                    color: #ffffff;\n                    text-align: left;\n                    th {\n                        text-align: center;\n                    }\n                }\n            }\n\n            tbody {\n                tr {\n                    border-bottom: 1px solid #dddddd;\n\n                    &:nth-of-type(even) {\n                        background-color: #f3f3f3;\n                    }\n                    &:first-of-type {\n                        border-top: 2px solid $nitroDark;\n                    }\n                    &:last-of-type {\n                        border-bottom: 2px solid $nitroDark;\n                    }\n\n                    td {\n                        padding: 12px 15px;\n                        word-wrap: break-word;\n                        .input_number {\n                            border-radius: 3px;\n                            border: 2px solid $nitroDark;\n                            width: 50px;\n                            height: 3vh;\n                            text-align: center;\n                        }\n                        input::-webkit-outer-spin-button,\n                        input::-webkit-inner-spin-button {\n                            -webkit-appearance: none;\n                            margin: 0;\n                        }\n                        button {\n                            width: 100%;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .table {\n        @media (max-width: $tablet) {\n            td:nth-of-type(1):before {\n                content: \"Product\";\n            }\n            td:nth-of-type(2):before {\n                content: \"Quantity\";\n            }\n            td:nth-of-type(3):before {\n                content: \"Remove\";\n            }\n        }\n        input {\n            border-radius: 3px;\n            width: 50px;\n        }\n    }\n\n    .btn_section {\n        margin: 3vh auto;\n        button {\n            width: 50%;\n            min-width: 300px;\n        }\n    }\n}\n","//Colors\n$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n$white: #fff;\n$black: #000;\n$success: #b6fcc9;\n$green: #357a38;\n\n//Heights\n$nav-height: 10vh;\n$main-height: 89vh;\n$footer-height: 6vh;\n\n//Breakpoints\n$mobile: 600px;\n$tablet: 1000px;\n$desktop: 1300px;\n\n//Layout\n@mixin flex(\n    $justify: \"center\",\n    $align: \"center\",\n    $direction: \"row\",\n    $gap: \"10px\"\n) {\n    display: flex;\n    justify-content: $justify;\n    align-items: $align;\n    flex-direction: $direction;\n    gap: $gap;\n}\n\n//Overflow\n@mixin scrollbars(\n    $size,\n    $foreground-color,\n    $background-color: mix($foreground-color, white, 50%)\n) {\n    // For Google Chrome\n    &::-webkit-scrollbar {\n        width: $size;\n        height: $size;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: $foreground-color;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $background-color;\n    }\n\n    // For Internet Explorer\n    & {\n        scrollbar-face-color: $foreground-color;\n        scrollbar-track-color: $background-color;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
